module.exports = __webpack_public_path__ + "img/section4.32f23d0c.png";